import * as React from 'react';
import {Component} from 'react';
import {observer} from 'mobx-react';
import * as commonScreenActions from '../../Screens/Common/actions/Screen';
import {runPackagesPanel} from '../../Screens/Design/actions/Screen';
import * as screenActions from '../../Screens/Design/actions/Screen';
import * as messageActions from '../../../_shared/Messages/actions/MessageActions';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import SidePanel from '../../../components/Common/SidePanel';
import Tabs, {TabPanel} from '../../../components/Common/Tabs';
import {Button} from '../../../components/Common/Buttons/Button';
import Screen from '../../Screens/Common/components/Screen';
import {messagesIds} from '../../../_shared/Messages/consts';
import messagesText, {moreInfoText} from '../../../_shared/Messages/texts';

@observer
class ScreensContent extends Component<any, any> {
    constructor(props) {
        super(props);

        this.onSelectScreen = this.onSelectScreen.bind(this);
    }

    onSelectScreen(selectedKey) {
        const {screensStore, changeScreen} = this.props;
        changeScreen(screensStore, selectedKey);
    }

    render() {
        const {screensStore, hiddenMenu} = this.props;
        const {screens, selectedScreenKey, selectedScreen} = screensStore;
        const screenKeys = Object.keys(screens);
        const tabs = screenKeys.map(key => ({
            key,
            title: screens[key].title
        }));

        return (
            <Tabs
                tabs={tabs}
                selectedKey={selectedScreenKey}
                onSelect={this.onSelectScreen}
                hiddenMenu={hiddenMenu}
                oneScreenStore={screensStore.oneScreenStore}
                disabled={selectedScreen && selectedScreen.loading}
            >
                {screenKeys.map(key => (
                    <TabPanel key={key}>
                        <div className={`options ${screensStore.oneScreenStore && 'no-choice'}`}>
                            <Screen screen={screens[key]} {...this.props} />
                        </div>
                    </TabPanel>
                ))}
            </Tabs>
        );
    }
}

@observer
export default class ScreensSidePanel extends Component<any, any> {
    screensStore;
    panel;

    constructor(props) {
        super(props);

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.save = this.save.bind(this);
        this.runPackages = this.runPackages.bind(this);

        this.renderContent = this.renderContent.bind(this);
    }

    componentDidMount() {
        this.panel.open();
    }

    componentDidUpdate() {
        this.panel.open();
    }

    onOpen() {
        const {screensStore, isDirty} = this.props;
        const {isReloadNeeded} = screensStore;
        if (isDirty) {
            messageActions.showWarnMessage({
                id: messagesIds.screens.onOpenIsDirtyWarn,
                title: getLocalizedText(texts.formReenter),
                onClose: () => {
                    commonScreenActions.closePanel(screensStore);
                    this.panel.hide();
                }
            });
            return false;
        }
        isReloadNeeded && screenActions.cancelReloadNeeded(screensStore);
        return true;
    }

    onClose(closeCallback) {
        const {screensStore} = this.props;
        const {selectedScreen, isReloadNeeded} = screensStore;
        if (selectedScreen.changed) {
            messageActions.showConfirmMessage({
                title: messagesText.shouldSaveChangesTitle,
                content: messagesText.shouldSaveChangesContent,
                moreInfo: moreInfoText?.shouldSaveChangesContent,
                confirmButtonText: messagesText.yesExitSearch,
                cancleButtonText: messagesText.cancel,
                defaultButton: 0,
                onConfirm: () => {
                    commonScreenActions.closePanel(screensStore);
                    closeCallback();
                }
            });

            return false;
        } else if (isReloadNeeded) {
            messageActions.showWarnMessage({
                id: messagesIds.screens.onCloseWarn,
                title: getLocalizedText(texts.formReenter),
                onClose: () => {
                    commonScreenActions.closePanel(screensStore);
                    this.panel.hide();
                }
            });
            return false;
        } else {
            //setTimeout(() => {
            commonScreenActions.closePanel(this.props.screensStore);
            //}, 1000);
            return true;
        }
    }

    save() {
        const {screensStore, handleSave} = this.props;
        handleSave(screensStore, this.panel.close);
    }

    runPackages() {
        const {screensStore, handleSave} = this.props;
        const {selectedScreen} = screensStore;
        const callback = () => {
            this.panel.hide();
            commonScreenActions.closePanel(this.props.screensStore, () =>
                runPackagesPanel(screensStore)
            );
            //runPackagesPanel(this.props.screensStore);
        };
        if (selectedScreen.changed) {
            messageActions.showUnsavedChangesMessages(
                getLocalizedText(texts.unsavedChangesWarn),
                () => handleSave(screensStore, callback),
                callback
            );
        } else {
            callback();
        }
    }

    renderPackagesHint() {
        const {selectedScreen} = this.props.screensStore;
        return selectedScreen.hasPackagesData ? (
            <div className="trapezoid">
                <div className="packages-label">
                    <div className="packs-title">{getLocalizedText(texts.packagesName)}</div>
                    <div>{getLocalizedText(texts.packagesTipTitle)}</div>
                </div>
                <div className="packages-tip">
                    <div className="tip">{getLocalizedText(texts.packagesTip)}</div>
                    <div className="tip">{getLocalizedText(texts.packagesTip2)}</div>
                </div>
                <Button
                    componentClasses="packages-btn"
                    text={getLocalizedText(texts.packages)}
                    onClick={this.runPackages}
                />
            </div>
        ) : null;
    }

    renderContent(sidePanelProps) {
        return (
            <div>
                <ScreensContent
                    {...sidePanelProps}
                    screensStore={this.props.screensStore}
                    {...this.props}
                />
                {this.renderPackagesHint()}
            </div>
        );
    }

    render() {
        const {title, subTitle, className} = this.props;

        return (
            <div>
                <SidePanel
                    ref={p => (this.panel = p)}
                    title={title}
                    subTitle={subTitle}
                    onOpen={this.onOpen}
                    onClose={this.onClose}
                    className={className}
                    content={this.renderContent}
                />
            </div>
        );
    }
}
